module.exports = __webpack_public_path__ + "static/media/imgSlider.e96f8f95.png";